import { render, staticRenderFns } from "./dict-horizontal.vue?vue&type=template&id=0513d488&"
import script from "./dict-horizontal.vue?vue&type=script&lang=js&"
export * from "./dict-horizontal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports